var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"sonar-icon",class:{'left': _vm.position == 'left', 'right': _vm.position == 'right', 'spinning': _vm.spinning == true, highlight : _vm.hasHighlight},attrs:{"aria-hidden":"true","focusable":"false"}},[_c('use',_vm._b({},'use',{'xlink:href' : '/static/symbol-defs.svg#icon-' + _vm.iconRef + '-outline'},false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e958513c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base-components/base-icon.vue
// module id = null
// module chunks = 